var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c(
          "div",
          {
            staticClass:
              "l-m-b-20 align-items-center d-flex justify-content-between"
          },
          [
            _c(
              "div",
              { staticClass: "col-8 d-flex align-items-center title-search" },
              [
                _c("h1", { staticClass: "pr-3" }, [_vm._v("Jobs")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group search" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn input-group-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.clearSearch }
                    },
                    [
                      _c("i", {
                        class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.q,
                        expression: "q"
                      }
                    ],
                    staticClass: "form-control search-input",
                    attrs: { type: "text", placeholder: "Search" },
                    domProps: { value: _vm.q },
                    on: {
                      keydown: function($event) {
                        _vm.searchText($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.q = $event.target.value
                      }
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-2" },
              [
                _c("load-filter-dropdown", {
                  attrs: { route: _vm.$route.name },
                  on: {
                    filterSelected: _vm.loadFilters,
                    filterTemplatesInitialized:
                      _vm.setFilterTemplatesInitialized
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-2 text-right pr-0 mobile-hidden" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-schedule",
                    attrs: { tag: "button", to: "/schedule" }
                  },
                  [_vm._v("\n          SCHEDULE\n        ")]
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center d-md-none"
          },
          [
            _vm.meta
              ? _c("div", { staticClass: "number-of-jobs" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.meta.to) +
                      " of " +
                      _vm._s(_vm.meta.total) +
                      " "
                  ),
                  _c("span", { staticClass: "us-hidden" }, [_vm._v("Jobs")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "col-12 text-right pr-0" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-schedule btn-refine",
                    on: {
                      click: function($event) {
                        _vm.showMobileFilters = true
                      }
                    }
                  },
                  [
                    _vm.isActiveFilters || _vm.selectedKey
                      ? _c("span", {
                          staticClass: "mobile-dot-refine-active-filters"
                        })
                      : _vm._e(),
                    _vm._v("\n            REFINE\n          ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary expand-all",
                    on: { click: _vm.toggleAllJobs }
                  },
                  [
                    _c("i", {
                      class: [
                        _vm.jobs && _vm.expandedAll
                          ? "fa fa-compress"
                          : "fa fa-expand"
                      ]
                    })
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex mobile-hidden justify-content-between" },
          [
            _c("div", { staticClass: "filters-field" }, [
              _c("span", [_vm._v("Filters:")]),
              _vm._v(" "),
              _vm.filtersLoaded
                ? _c("span", [
                    _vm.filters.cash_collected
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("cash_collected")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Cash collected: " +
                                _vm._s(
                                  _vm.filters.cash_collected === "true"
                                    ? "Yes"
                                    : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.carrier.length && _vm.carriers
                      ? _c(
                          "span",
                          _vm._l(_vm.filters.carrier, function(carrier) {
                            return _c(
                              "span",
                              {
                                key: carrier,
                                staticClass: "filter-item btn btn-filter"
                              },
                              [
                                _c("span", {
                                  staticClass: "mod-icon-filter",
                                  on: {
                                    click: function($event) {
                                      _vm.removeFilter("carrier", carrier)
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n              Carrier: " +
                                    _vm._s(
                                      _vm.carriers.find(function(el) {
                                        return el.id === carrier
                                      }).name
                                    )
                                )
                              ]
                            )
                          })
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.company.length && _vm.companies
                      ? _c(
                          "span",
                          _vm._l(_vm.filters.company, function(company) {
                            return _c(
                              "span",
                              {
                                key: company,
                                staticClass: "filter-item btn btn-filter"
                              },
                              [
                                _c("span", {
                                  staticClass: "mod-icon-filter",
                                  on: {
                                    click: function($event) {
                                      _vm.removeFilter("company", company)
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n              Company: " +
                                    _vm._s(
                                      _vm.companies.find(function(el) {
                                        return el.id === company
                                      }).name
                                    )
                                )
                              ]
                            )
                          })
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.moveSize
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("moveSize")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Move Size: " +
                                _vm._s(
                                  _vm.moveSizes.find(function(el) {
                                    return el.id === _vm.filters.moveSize
                                  }).name
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.move_date
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("move_date")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Move Date: " +
                                _vm._s(_vm.filters.move_date)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.created_at
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("created_at")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Created At: " +
                                _vm._s(_vm.filters.created_at)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.clusterUser.length && _vm.salesFilter.length
                      ? _c(
                          "span",
                          _vm._l(_vm.filters.clusterUser, function(
                            clusterUser
                          ) {
                            return _c(
                              "span",
                              {
                                key: clusterUser,
                                staticClass: "filter-item btn btn-filter"
                              },
                              [
                                _c("span", {
                                  staticClass: "mod-icon-filter",
                                  on: {
                                    click: function($event) {
                                      _vm.removeFilter(
                                        "clusterUser",
                                        clusterUser
                                      )
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n              Sales: " +
                                    _vm._s(
                                      _vm.salesFilter.find(function(el) {
                                        return el.id === clusterUser
                                      }).full_name
                                    )
                                )
                              ]
                            )
                          })
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.recurlyPlan.length && _vm.plans.length
                      ? _c(
                          "span",
                          _vm._l(_vm.filters.recurlyPlan, function(
                            recurlyPlan
                          ) {
                            return _c(
                              "span",
                              {
                                key: recurlyPlan,
                                staticClass: "filter-item btn btn-filter"
                              },
                              [
                                _c("span", {
                                  staticClass: "mod-icon-filter",
                                  on: {
                                    click: function($event) {
                                      _vm.removeFilter(
                                        "recurlyPlan",
                                        recurlyPlan
                                      )
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n              Plans: " +
                                    _vm._s(
                                      _vm.plans.find(function(el) {
                                        return el.id === recurlyPlan
                                      }).name
                                    )
                                )
                              ]
                            )
                          })
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.userCompanies && _vm.clusterUsersFilter.length
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("userCompanies")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            User companies: " +
                                _vm._s(
                                  _vm.clusterUsersFilter.find(function(el) {
                                    return el.id === _vm.filters.userCompanies
                                  }).full_name
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.status
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("status")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Status: " +
                                _vm._s(
                                  _vm.jobStatuses.find(function(el) {
                                    return el.id === _vm.filters.status
                                  }).name
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.source
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("source")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Source: " +
                                _vm._s(
                                  _vm.sources.find(function(el) {
                                    return el.id === _vm.filters.source
                                  }).name
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.leadSourceId
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("leadSourceId")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Lead Source: " +
                                _vm._s(
                                  _vm.sources.find(function(el) {
                                    return el.id === _vm.filters.leadSourceId
                                  }).name
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.canceled === "false"
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("canceled")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Show Canceled: " +
                                _vm._s(
                                  _vm.filters.canceled === "true" ? "Yes" : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.feeChange
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("feeChange")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Fee Changes Required: " +
                                _vm._s(
                                  _vm.filters.feeChange === "true"
                                    ? "Yes"
                                    : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.hasClaim
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("hasClaim")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Has claim: " +
                                _vm._s(
                                  _vm.filters.hasClaim === "true" ? "Yes" : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.hasHeavyItems
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("hasHeavyItems")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Has heavy items: " +
                                _vm._s(
                                  _vm.filters.hasHeavyItems === "true"
                                    ? "Yes"
                                    : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.hasSubscription
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("hasSubscription")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Has subscription: " +
                                _vm._s(
                                  _vm.filters.hasSubscription === "true"
                                    ? "Yes"
                                    : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.offers_sent
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("offers_sent")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Offers sent: " +
                                _vm._s(
                                  _vm.filters.offers_sent === "true"
                                    ? "Yes"
                                    : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.organic_bookings
                      ? _c(
                          "span",
                          { staticClass: "filter-item btn btn-filter" },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("organic_bookings")
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Organic bookings: " +
                                _vm._s(
                                  _vm.filters.organic_bookings === "true"
                                    ? "Yes"
                                    : "No"
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filters.tags && _vm.filters.tags.length && _vm.tags
                      ? _c(
                          "span",
                          _vm._l(_vm.filters.tags, function(tag) {
                            return _c(
                              "span",
                              {
                                key: tag,
                                staticClass: "filter-item btn btn-filter"
                              },
                              [
                                _c("span", {
                                  staticClass: "mod-icon-filter",
                                  on: {
                                    click: function($event) {
                                      _vm.removeFilter("tags", tag)
                                    }
                                  }
                                }),
                                _vm._v(
                                  "\n              Tag: " +
                                    _vm._s(
                                      _vm.tags.find(function(el) {
                                        return el.id === tag
                                      }).name
                                    ) +
                                    " "
                                )
                              ]
                            )
                          })
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary add-filters",
                  on: {
                    click: function($event) {
                      _vm.showFilters = true
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus filter-icon" })]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-end pr-0",
                staticStyle: { "min-width": "200px" }
              },
              [
                _c("div", { staticClass: "dropdown" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-secondary sort-button sort-button-selected",
                      attrs: {
                        id: "dropdownMenuButton",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _vm.selectedKey.length
                        ? _c("i", {
                            staticClass: "fa pr-2",
                            class: [
                              _vm.ascOrDesc === "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                            ]
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedKey === "created_at"
                        ? _c("span", [
                            _vm._v("\n              Created at\n            ")
                          ])
                        : _vm.selectedKey === "move_date"
                          ? _c("span", [
                              _vm._v("\n              Move date\n            ")
                            ])
                          : _c("span", [
                              _vm._v("\n              Sort by\n            ")
                            ]),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-caret-down caret" })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-menu sort-dropdown dropdown-menu-right",
                      attrs: { "aria-labelledby": "dropdownMenuButton" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "dropdown-item sort-dropdown-item nav-link btn",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.sortBy("created_at")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                _vm.selectedKey === "created_at"
                                  ? "selected"
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                "\n                Created date\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm.selectedKey === "created_at"
                              ? _c("i", {
                                  staticClass: "fa",
                                  class: [
                                    _vm.ascOrDesc === "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                  ]
                                })
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "dropdown-item sort-dropdown-item nav-link btn",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.sortBy("move_date")
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                _vm.selectedKey === "move_date"
                                  ? "selected"
                                  : ""
                              ]
                            },
                            [
                              _vm._v(
                                "\n                Move date\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm.selectedKey === "move_date"
                              ? _c("i", {
                                  staticClass: "fa",
                                  class: [
                                    _vm.ascOrDesc === "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                  ]
                                })
                              : _vm._e()
                          ])
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary expand-all",
                    on: { click: _vm.toggleAllJobs }
                  },
                  [
                    _c("i", {
                      class: [
                        _vm.jobs && _vm.expandedAll
                          ? "fa fa-compress"
                          : "fa fa-expand"
                      ]
                    })
                  ]
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.jobs
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "blocks" },
              _vm._l(_vm.jobs, function(job, index) {
                return _c("JobsBlock", {
                  key: index,
                  attrs: {
                    job: job,
                    q: _vm.q,
                    expanded: _vm.expanded,
                    "job-loading": _vm.jobLoading
                  },
                  on: {
                    "update:job": function($event) {
                      job = $event
                    },
                    "update:q": function($event) {
                      _vm.q = $event
                    },
                    "job-updated": function($event) {
                      _vm.updateJob(_vm.jobs, index, $event)
                    },
                    expanded: _vm.toggleJob,
                    setFiltersSaved: _vm.callSetFiltersSaved,
                    showModalAcceptJob: function($event) {
                      _vm.showModalAcceptJob = true
                    }
                  }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-md-6 mb-1 text-black-50 d-none d-md-block jobs-meta"
                      },
                      [
                        _vm._v(
                          "\n        Showing " +
                            _vm._s(_vm.meta.from) +
                            " - " +
                            _vm._s(_vm.meta.to) +
                            " of " +
                            _vm._s(_vm.meta.total) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-md-6 mb-1 jobs-pagination",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "filters-side-modal flex flex-column justify-content-between"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters\n            button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.companies && _vm.companies.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Company")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.companies,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "company-select",
                                              placeholder: "Select Company",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.company"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.carriers && _vm.carriers.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carriers")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "carrier-select",
                                              placeholder: "Select Carrier",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move Size")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.moveSizes,
                                          "input-id": "move-sizes-select",
                                          placeholder: "Select Move Size"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.moveSize,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "moveSize",
                                              $$v
                                            )
                                          },
                                          expression: "filters.moveSize"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move date")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Move Date",
                                          name: "date"
                                        },
                                        on: {
                                          "on-close": _vm.onMoveDateChange
                                        },
                                        model: {
                                          value: _vm.filters.move_date,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "move_date",
                                              $$v
                                            )
                                          },
                                          expression: "filters.move_date"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.move_date
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click:
                                                  _vm.clearMoveDateAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Booked At")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Booking Date",
                                          name: "date"
                                        },
                                        on: {
                                          "on-close": _vm.onCreatedDateChange
                                        },
                                        model: {
                                          value: _vm.filters.created_at,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "created_at",
                                              $$v
                                            )
                                          },
                                          expression: "filters.created_at"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.created_at
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click:
                                                  _vm.clearCreatedDateAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.salesFilter && _vm.salesFilter.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Sales Rep.")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.salesFilter,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              id: "sales-select",
                                              placeholder: "Select Sales",
                                              "preserve-search": false,
                                              label: "full_name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option
                                                                .full_name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.clusterUser,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "clusterUser",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.clusterUser"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.plans && _vm.plans.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Recurly Plan")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.plans,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              id: "plans-select",
                                              placeholder: "Select Plan",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.recurlyPlan,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "recurlyPlan",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.recurlyPlan"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.clusterUsersFilter &&
                                _vm.clusterUsersFilter.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [
                                            _vm._v("User companies")
                                          ]),
                                          _vm._v(" "),
                                          _c("simple-select", {
                                            attrs: {
                                              options: _vm.clusterUsersFilter,
                                              "input-id":
                                                "user-companies-select",
                                              placeholder: "Select User",
                                              "track-by": "id",
                                              label: "full_name"
                                            },
                                            on: { input: _vm.search },
                                            model: {
                                              value: _vm.filters.userCompanies,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "userCompanies",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.userCompanies"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.jobStatuses,
                                          "input-id": "status-select",
                                          placeholder: "Select Status"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Source")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.sources,
                                          "input-id": "source-select",
                                          placeholder: "Select Source"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.source,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "source", $$v)
                                          },
                                          expression: "filters.source"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Lead Source")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.sources,
                                          "input-id": "source-select",
                                          placeholder: "Select Lead Source"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.leadSourceId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "leadSourceId",
                                              $$v
                                            )
                                          },
                                          expression: "filters.leadSourceId"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Show canceled")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "canceled-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.canceled,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "canceled",
                                              $$v
                                            )
                                          },
                                          expression: "filters.canceled"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [
                                        _vm._v("Fee Changes Required")
                                      ]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "fee-changes-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.feeChange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "feeChange",
                                              $$v
                                            )
                                          },
                                          expression: "filters.feeChange"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Has claim")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-claim-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.hasClaim,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "hasClaim",
                                              $$v
                                            )
                                          },
                                          expression: "filters.hasClaim"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Has heavy items")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-heavy-items-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.hasHeavyItems,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "hasHeavyItems",
                                              $$v
                                            )
                                          },
                                          expression: "filters.hasHeavyItems"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Has subscription")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-subscription-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.hasSubscription,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "hasSubscription",
                                              $$v
                                            )
                                          },
                                          expression: "filters.hasSubscription"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Offers sent")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "offers-sent-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.offers_sent,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "offers_sent",
                                              $$v
                                            )
                                          },
                                          expression: "filters.offers_sent"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Organic bookings")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id":
                                            "offers-organic_bookings-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.organic_bookings,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "organic_bookings",
                                              $$v
                                            )
                                          },
                                          expression: "filters.organic_bookings"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.$_can("tags.show") &&
                                _vm.tags &&
                                _vm.tags.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Tags")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            staticClass: "w-100",
                                            attrs: {
                                              options: _vm.tags,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "track-by": "id",
                                              label: "name"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag p-0 bg-transparent"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _c("tag-color", {
                                                              attrs: {
                                                                color:
                                                                  props.option
                                                                    .color.name,
                                                                name:
                                                                  props.option
                                                                    .name
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "option",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "option__desc"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center justify-content-between"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "option__title"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      props
                                                                        .option
                                                                        .name
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.tags,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "tags",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.tags"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Cash collected")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-subscription-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.cash_collected,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "cash_collected",
                                              $$v
                                            )
                                          },
                                          expression: "filters.cash_collected"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.clearFilters()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary text-white w-100",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.saveFiltersModal = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Save filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showMobileFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showMobileFilters = false
                  }
                }
              },
              [
                _vm.showMobileFilters
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "filters-side-modal flex flex-column mobile-modal"
                      },
                      [
                        _c("div", { staticClass: "pointer" }, [
                          _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                            _c("span", {
                              staticClass: "btn btn-back",
                              on: {
                                click: function($event) {
                                  _vm.showMobileFilters = !_vm.showMobileFilters
                                }
                              }
                            }),
                            _vm._v(
                              "Apply\n            sorting and filters\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c("h5", [_vm._v("Sort by")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row mb-3" }, [
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            _vm.selectedKey === "created_at"
                                              ? "text-primary"
                                              : "text-secondary"
                                          ]
                                        },
                                        [_vm._v("Created date")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-prepend"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn",
                                                  class: [
                                                    _vm.selectedKey ===
                                                      "created_at" &&
                                                    _vm.ascOrDesc === "asc"
                                                      ? "btn-active"
                                                      : "btn-not-active"
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      _vm.triggerMobileSortBy(
                                                        "created_at",
                                                        "asc"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa text-dark",
                                                    class: [
                                                      "fa-sort-amount-asc"
                                                    ]
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn",
                                                  class: [
                                                    _vm.selectedKey ===
                                                      "created_at" &&
                                                    _vm.ascOrDesc === "desc"
                                                      ? "btn-active"
                                                      : "btn-not-active"
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      _vm.triggerMobileSortBy(
                                                        "created_at",
                                                        "desc"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa text-dark",
                                                    class: [
                                                      "fa-sort-amount-desc"
                                                    ]
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            _vm.selectedKey === "move_date"
                                              ? "text-primary"
                                              : "text-secondary"
                                          ]
                                        },
                                        [_vm._v("Move date")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-prepend"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn",
                                                  class: [
                                                    _vm.selectedKey ===
                                                      "move_date" &&
                                                    _vm.ascOrDesc === "asc"
                                                      ? "btn-active"
                                                      : "btn-not-active"
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      _vm.triggerMobileSortBy(
                                                        "move_date",
                                                        "asc"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa text-dark",
                                                    class: [
                                                      "fa-sort-amount-asc"
                                                    ]
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn",
                                                  class: [
                                                    _vm.selectedKey ===
                                                      "move_date" &&
                                                    _vm.ascOrDesc === "desc"
                                                      ? "btn-active"
                                                      : "btn-not-active"
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      _vm.triggerMobileSortBy(
                                                        "move_date",
                                                        "desc"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa text-dark",
                                                    class: [
                                                      "fa-sort-amount-desc"
                                                    ]
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-12 mb-3 pt-3 border-top"
                                  },
                                  [_c("h5", [_vm._v("Filters")])]
                                ),
                                _vm._v(" "),
                                _vm.companies && _vm.companies.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Company")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.companies,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "company-select",
                                              placeholder: "Select Company",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.company"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.carriers && _vm.carriers.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carriers")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "carrier-select",
                                              placeholder: "Select Carrier",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move Size")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.moveSizes,
                                          "input-id": "move-sizes-select",
                                          placeholder: "Select Move Size"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.moveSize,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "moveSize",
                                              $$v
                                            )
                                          },
                                          expression: "filters.moveSize"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move date")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Move Date",
                                          name: "date"
                                        },
                                        on: {
                                          "on-close": _vm.onMoveDateChange
                                        },
                                        model: {
                                          value: _vm.filters.move_date,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "move_date",
                                              $$v
                                            )
                                          },
                                          expression: "filters.move_date"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.move_date
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click:
                                                  _vm.clearMoveDateAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Booked At")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Booking Date",
                                          name: "date"
                                        },
                                        on: {
                                          "on-close": _vm.onCreatedDateChange
                                        },
                                        model: {
                                          value: _vm.filters.created_at,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "created_at",
                                              $$v
                                            )
                                          },
                                          expression: "filters.created_at"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.created_at
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click:
                                                  _vm.clearCreatedDateAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.salesFilter && _vm.salesFilter.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Sales Rep.")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.salesFilter,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              id: "sales-select",
                                              placeholder: "Select Sales",
                                              "preserve-search": false,
                                              label: "full_name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option
                                                                .full_name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.clusterUser,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "clusterUser",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.clusterUser"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.plans && _vm.plans.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Recurly Plan")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.plans,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "hide-selected": true,
                                              id: "plan-select",
                                              placeholder: "Select Plan",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.recurlyPlan,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "recurlyPlan",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.recurlyPlan"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.clusterUsersFilter &&
                                _vm.clusterUsersFilter.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [
                                            _vm._v("User companies")
                                          ]),
                                          _vm._v(" "),
                                          _c("simple-select", {
                                            attrs: {
                                              options: _vm.clusterUsersFilter,
                                              "input-id":
                                                "user-companies-select",
                                              placeholder: "Select User",
                                              "track-by": "id",
                                              label: "full_name"
                                            },
                                            on: { input: _vm.search },
                                            model: {
                                              value: _vm.filters.userCompanies,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "userCompanies",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.userCompanies"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.jobStatuses,
                                          "input-id": "status-select",
                                          placeholder: "Select Status"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Source")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.sources,
                                          "input-id": "source-select",
                                          placeholder: "Select Source"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.source,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "source", $$v)
                                          },
                                          expression: "filters.source"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Lead Source")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.sources,
                                          "input-id": "source-select",
                                          placeholder: "Select Lead Source"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.leadSourceId,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "leadSourceId",
                                              $$v
                                            )
                                          },
                                          expression: "filters.leadSourceId"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Show canceled")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "canceled-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.canceled,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "canceled",
                                              $$v
                                            )
                                          },
                                          expression: "filters.canceled"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [
                                        _vm._v("Fee Changes Required")
                                      ]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "fee-changes-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.feeChange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "feeChange",
                                              $$v
                                            )
                                          },
                                          expression: "filters.feeChange"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Has claim")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-claim-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.hasClaim,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "hasClaim",
                                              $$v
                                            )
                                          },
                                          expression: "filters.hasClaim"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Has heavy items")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-heavy-items-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.hasHeavyItems,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "hasHeavyItems",
                                              $$v
                                            )
                                          },
                                          expression: "filters.hasHeavyItems"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Has subscription")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-subscription-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.hasSubscription,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "hasSubscription",
                                              $$v
                                            )
                                          },
                                          expression: "filters.hasSubscription"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Offers sent")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "offers-sent-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.offers_sent,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "offers_sent",
                                              $$v
                                            )
                                          },
                                          expression: "filters.offers_sent"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Organic bookings")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id":
                                            "offers-organic_bookings-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.organic_bookings,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "organic_bookings",
                                              $$v
                                            )
                                          },
                                          expression: "filters.organic_bookings"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.$_can("tags.show")
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Tags")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            staticClass: "w-100",
                                            attrs: {
                                              options: _vm.tags,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "track-by": "id",
                                              label: "name"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag p-0 bg-transparent"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _c("tag-color", {
                                                              attrs: {
                                                                color:
                                                                  props.option
                                                                    .color.name,
                                                                name:
                                                                  props.option
                                                                    .name
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "option",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "option__desc"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center justify-content-between"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "option__title"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      props
                                                                        .option
                                                                        .name
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.tags,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "tags",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.tags"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-not-active w-100",
                                staticStyle: { color: "black" },
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _vm.clearFiltersButtonShouldBeDisabled &&
                                    !_vm.selectedKey
                                },
                                on: {
                                  click: function($event) {
                                    _vm.clearFilters(true)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Clear all\n            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary text-white w-100",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        _vm.saveFiltersModal = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Save filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 pt-2" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary w-100",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.filter()
                                    _vm.showMobileFilters = false
                                  }
                                }
                              },
                              [_vm._v("\n              Apply\n            ")]
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.saveFiltersModal
        ? _c("SaveFiltersModal", {
            attrs: { filters: _vm.filters, route: _vm.$route.path },
            on: {
              close: function($event) {
                _vm.saveFiltersModal = false
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-569ff32f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569ff32f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/Jobs.vue
// module id = null
// module chunks = 